module.exports = __webpack_public_path__ + "img/confort_termico_hover.63533108.png";